var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('el-row',{attrs:{"gutter":5}},[_c('el-col',{attrs:{"lg":8}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),(_vm.pagination)?_c('el-col',{attrs:{"offset":8,"lg":8}},[_c('PagePagination',{attrs:{"total":_vm.total},on:{"fetch":_vm.fetch}})],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }